"use client";

import React, { useEffect, useRef, useState } from "react";
import Link from "next/link";
import {
    User,
    Send,
    Phone,
    Headphones,
    MessageSquare,
    MessageCircleCheck,
    Plus,
} from "lucide-react";

import {ChatItem} from "@/types/contact";

const iconMap: Record<string, React.ElementType> = {
    User,
    Send,
    Phone,
    Headphones,
    MessageSquare,
    MessageCircleCheck,
    Plus,
};

const BtnFloatContact: React.FC = () => {
    const [isActive, setIsActive] = useState<boolean>(false);
    const popupRef = useRef<HTMLDivElement | null>(null);

    const chats: ChatItem[] = [
        // { href: "tel:+982144446012", title: "مدیریت", icon: "User" },
        { href: "https://t.me/Parhammee", title: "آیدی تلگرام", icon: "Send" },
        { href: "https://ble.ir/Asgardian0125", title: "پیگیری و پشتیبانی", icon: "MessageCircleCheck" },
        { href: "https://ble.ir/hoseini_ittelecom", title: "مدیر مالی و بازرگانی", icon: "MessageCircleCheck" },
        { href: "tel:+982144446012", title: "پشتیبانی", icon: "Headphones" },
        // { href: "tel:+982144446012", title: "تماس", icon: "Phone" },
    ];

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (
                popupRef.current &&
                !popupRef.current.contains(e.target as Node)
            ) {
                setIsActive(false);
            }
        };

        if (isActive) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isActive]);

    return (
        <div className="relative">
            {/* Button */}
            <button
                onClick={() => setIsActive(p => !p)}
                title={'راه‌های ارتباطی'}
                className="fixed bottom-10 right-10 z-10 w-12 h-12 rounded-full bg-green-700 hover:bg-green-800 flex items-center justify-center shadow-lg cursor-pointer"
            >
                <MessageSquare className="text-white w-6 h-6" />
            </button>

            {/* Popup */}
            <div
                ref={popupRef}
                className={`fixed bottom-24 right-10 z-20 w-72 bg-white rounded-lg shadow-2xl overflow-hidden transition-all duration-300 ${isActive ? "opacity-100 visible translate-y-0" : "opacity-0 invisible translate-y-[350px]"}`}
            >
                {/* Header */}
                <div className="flex justify-between items-center p-2 bg-green-700">
                    <span className="text-white">راه‌های ارتباطی</span>
                    <button
                        onClick={() => setIsActive(false)}
                        className="bg-gray-800/70 hover:bg-gray-800 rounded-lg p-1 cursor-pointer"
                    >
                        <Plus className="text-white rotate-45 w-5 h-5" />
                    </button>
                </div>

                {/* Body */}
                <div className="p-2">
                    <ul>
                        {chats.map((item, index) => {
                            const IconComponent = iconMap[item.icon];

                            return (
                                <li key={index} className="mb-1 last:mb-0">
                                    <Link
                                        href={item.href}
                                        target={item.href.startsWith("http") ? "_blank" : "_self"}
                                        className="flex items-center p-2 border text-gray-700 border-gray-300 rounded-lg hover:bg-gray-100 transition dark:border-gray-700 dark:hover:bg-gray-700">
                                        <div className="pl-2">
                                            {IconComponent && (
                                                <IconComponent className="w-5 h-5 text-gray-700 dark:text-white" />
                                            )}
                                        </div>
                                        <span className={'dark:text-white '}>{item.title}</span>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default BtnFloatContact;
